export const SITE = {
  name: "CCDKOFHAMILTON",
  tagline: "Free Laundry. Restored Dignity.",
  city: "Hamilton",
  email: "Ccdkofhamilton@outlook.com",
  phone: "(513) 000-0000",
  address: "Hamilton, Ohio",
  donateUrl: "https://venmo.com/u/ccdkofhamilton",
  hours: "Tue – Sat • 9:00 AM – 6:00 PM",
};

export const NAV_LINKS = [
  { label: "Mission", href: "#mission" },
  { label: "Impact", href: "#impact" },
  { label: "How It Works", href: "#how" },
  { label: "Request Help", href: "#request" },
  { label: "Contact", href: "#contact" },
];
